'Use strict';

class PendingSpendingsController {
    /* @ngInject */
    constructor(
        PendingSpendingsService,
        OrderTranslationService,
        $scope
    ) {
        Object.assign(this, {
            PendingSpendingsService,
            OrderTranslationService,
            $scope
        });

        this.query = {
            include: [
                'srcVoucher',
                'dstVoucher',
                'registry'
            ],
            where: {},
            limit: 10,
            page: 1,
            order: 'createdAt DESC',
            deleted: true
        };

        this.getModels();

        this.onPagination = () => {
            this.getModels();
        };

        this.onReorder = () => {
            this.getModels();
        };
        this.registries = $scope.$parent.$resolve.registries;
    }

    afterFirstSave() {
        this.neverEditable = true;
    }

    getModels() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.registry) {
            Object.assign(qOpts.where, {
                registryId: this.registry.id
            });
        }

        if (this.onlyNonDstVoucher) {
            Object.assign(qOpts.where, {
                dstVoucherId: null
            });
        }
        if (this.mdOrder) {
            qOpts.order = this.OrderTranslationService.translate(
                this.mdOrder
            );
        }

        let queryReady = this.PendingSpendingsService
            .getModels(qOpts)
            .then(pendingSpendings => {
                this.pendingSpendings = pendingSpendings;
            });
        let countReady = this.PendingSpendingsService
            .getCount(qOpts)
            .then(result => {
                this.pendingSpendingsCount = result.count;
            });
        return Promise.all([queryReady, countReady]);
    }

    queryRegistrySearch() {
        let matches = this.registries.filter(r => {
            let nameMatches = r.name.toLowerCase()
                .indexOf(this.searchRegistryText.toLowerCase()) > -1;
            return nameMatches;
        });
        return matches;
    }
}

export default PendingSpendingsController;
